import { SvgIcon } from "@mui/material";

function LoadingSvg() {
  return (
    <SvgIcon viewBox="0 0 120 120">
      <g>
        <path
          d="M50 15A35 35 0 1 0 74.74873734152916 25.251262658470843"
          fill="none"
          stroke="#e15b64"
          strokeWidth="12"
        ></path>
        <path d="M49 3L49 27L61 15L49 3" fill="#e15b64"></path>
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </g>
    </SvgIcon>
  );
}

export { LoadingSvg };
